import script from "./DuplicateArtworkNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./DuplicateArtworkNotice.vue?vue&type=script&setup=true&lang=js"

import "./DuplicateArtworkNotice.vue?vue&type=style&index=0&id=1110e495&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1110e495"]])

export default __exports__